import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LeadForm = ({ headline, source }) => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/subscribe`, { email, source });
      setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not subscribe. Check the email.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <aside className="border border-volt/40 bg-volt/5 p-6 sm:p-8 my-10" data-testid="article-lead-form">
      <p className="eyebrow mb-2 flex items-center gap-2"><Mail size={13} /> Stay in the loop</p>
      <p className="font-head font-extrabold uppercase text-xl sm:text-2xl tracking-tight mb-4">{headline}</p>
      {done ? (
        <p className="flex items-center gap-2 text-volt font-mono2 text-sm uppercase tracking-wider" data-testid="lead-form-success">
          <CheckCircle2 size={16} /> You're on the list.
        </p>
      ) : (
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@email.com"
            className="volt-input flex-1"
            data-testid="lead-form-email-input"
          />
          <button type="submit" disabled={busy} className="btn-volt justify-center disabled:opacity-60" data-testid="lead-form-submit-button">
            {busy ? "Joining..." : "Notify Me"}
          </button>
        </form>
      )}
      <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-zinc-600 mt-3">
        Sim dates, results and booking windows only. Unsubscribe anytime.
      </p>
    </aside>
  );
};
